import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=6d22e625&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2983364112/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d22e625')) {
      api.createRecord('6d22e625', component.options)
    } else {
      api.reload('6d22e625', component.options)
    }
    module.hot.accept("./Profile.vue?vue&type=template&id=6d22e625&", function () {
      api.rerender('6d22e625', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Profile.vue"
export default component.exports